export default __webpack_public_path__ + "static/media/icon_alerta.0131c9e7.svg";